import {PageBaseSection} from "../PageBaseSection";

export enum TextImagesTypes {
  ONE_IMAGE_3_5 = "one_image_3-5",
  ONE_IMAGE_1_2 = "one_image_1-2",
  ONE_IMAGE_4_12 = "one_image_4-12",
  ONE_IFRAME_1_2 = "one_iframe_1-2",
  ONE_INSTRAGRAM_1_2 = "one_instagram_1-2",
  FULL_TEXT = "full_text",
  FULL_IFRAME = "full_iframe",
  FULL_IMAGE = "full_image",
  FULL_INSTAGRAM = "full_instagram",
  TWO_IMAGES_CENTER = "two_images_center",
  TWO_IMAGES_DIAG = "two_images_diag",
  TERRE_CONTRASTES = "terre_contrastes"
}

export enum TextImagesDirections {
  LEFT = "left",
  RIGHT = "right",
}

export class PageTextImagesSection extends PageBaseSection{
  content: string;
  embed: string;
  instagram: string;
  type:TextImagesTypes;
  direction:TextImagesDirections;
  gallery: number[];
  suggestions_title: string;
  selection_sit: string;
  filtres_sit: string;
  nb_items_sit: number;
  ids_sit: string;
}
